module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-07-a9ae3671.webp";